module.exports = __webpack_public_path__ + "static/media/qr1.f409eb8e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/Tutorial/screenshots/Creating/qr1.jpg
// module id = 1624
// module chunks = 0